var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import cls from 'classnames';
import { useSearchModule } from '../hooks/useSearchModule';
import { useSelector } from '../store/useSelector';
import { Odds } from './Odds';
export function MarketOddsDisplaySelection({ value, position, searchSection, matchId, }) {
    const searchModule = useSearchModule();
    const selectedSelection = useSelector((state) => state.selectedSelections[value.id]) || {
        fixed: false,
        sp: false,
    };
    return (React.createElement("div", { className: "WhSearch-MarketOddsDisplay__selection" },
        React.createElement("div", { className: "WhSearch-MarketOddsDisplay__selectionName" }, value.name),
        React.createElement("div", { className: "WhSearch-MarketOddsDisplay__selectionOdds" },
            React.createElement(Odds, { stopPropagation: true, selected: selectedSelection.fixed, currentPriceNum: value.currentPriceNum, currentPriceDen: value.currentPriceDen, fallback: "-", disabled: !value.active, onClick: () => searchModule.emit('oddClicked', {
                    selection: value,
                    sp: false,
                    status: !selectedSelection.fixed,
                    position: position,
                    searchSection: searchSection,
                    matchId: matchId,
                }) }))));
}
export function MarketOddsDisplay(_a) {
    var { value, className, position, searchSection, matchId } = _a, props = __rest(_a, ["value", "className", "position", "searchSection", "matchId"]);
    const sortedSelections = useMemo(() => value.selections.slice().sort((x, y) => x.order - y.order), [value.selections]);
    const finalClassName = cls('WhSearch-MarketOddsDisplay', className);
    return (React.createElement("div", Object.assign({ className: finalClassName }, props), sortedSelections.map((selection) => (React.createElement(MarketOddsDisplaySelection, { key: selection.id, value: selection, position: position, searchSection: searchSection, matchId: matchId })))));
}
//# sourceMappingURL=MarketOddsDisplay.js.map